import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    isLogin: Boolean,
    message: {
      type: String,
      default: "ログインもしくはアカウント登録してください。",
    },
  };

  click(event) {
    if (this.isLoginValue) {
      // ログイン済みは通常通り遷移
      return true;
    }

    // 未ログインの場合はイベント停止 + トースト表示
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    this.showToast();
    return false;
  }

  showToast() {
    const toastFrame = document.querySelector("#toast");
    if (!toastFrame) {
      console.warn("Toast frame not found");
      return;
    }

    // アプリ時はヘッダーに隠れないように上に余白を追加
    const isNativeApp = document.body.classList.contains("native");
    // top-20 (80px) は暫定値なので調整が必要
    const topClass = isNativeApp ? "top-20" : "top-6";

    const toastHTML = `
      <div class="fixed ${topClass} right-1/2 translate-x-1/2 z-[61] flex flex-col gap-2 w-full px-4" data-controller="resumin--toast">
        <div class="c-toast c-toast-visible bg-slate-900 text-white shadow-[0_1px_8px_2px_rgba(0,0,0,0.1)]" aria-live="polite">
          <p class="text-xs">
            ${this.messageValue}
          </p>
        </div>
      </div>
    `;

    // トーストフレームを更新（既存のtoast_controllerが自動で制御）
    toastFrame.innerHTML = toastHTML;
  }
}
